"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualConnectionsDisplayGrid = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const LinkCellFormatter_1 = require("../datagrid/cellFormatters/LinkCellFormatter");
const ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
const UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
const LabelsHookHelper_1 = require("../Labels/LabelsHookHelper");
const shouldBeObfuscated = ({ name }) => name === null;
const projectContainerType = 'Project';
function columns(siteUrls) {
    const cols = [
        () => createLabelGridColumnFormatter(siteUrls, 'CERTIFICATION'),
        () => createLabelGridColumnFormatter(siteUrls, 'WARNING'),
        (sortParams) => ({
            name: 'name',
            dataKey: catalog_queries_1.VirtualConnectionOrderField.NAME,
            headerText: catalog_messages_1.Messages.GridHeaderName(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter)(shouldBeObfuscated, ({ name }) => name, (urls, { vizportalUrlId }) => urls.virtualConnectionLineagePath(vizportalUrlId)),
            resizable: true,
            sortable: true,
        }),
        (sortParams) => ({
            name: 'workbooks',
            dataKey: catalog_queries_1.VirtualConnectionOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
            headerText: catalog_messages_1.Messages.GridHeaderWorkbooks(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(({ downstreamWorkbooksConnection }) => downstreamWorkbooksConnection
                ? catalog_messages_1.Formatters.formatCount(downstreamWorkbooksConnection.totalCount)
                : null),
            resizable: true,
            sortable: true,
        }),
        (sortParams) => ({
            name: 'datasources',
            dataKey: catalog_queries_1.VirtualConnectionOrderField.DOWNSTREAM_DATASOURCES_COUNT,
            headerText: catalog_messages_1.Messages.GridHeaderDatasources(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(({ downstreamDatasourcesConnection }) => downstreamDatasourcesConnection
                ? catalog_messages_1.Formatters.formatCount(downstreamDatasourcesConnection.totalCount)
                : null),
            resizable: true,
            sortable: true,
        }),
        (sortParams) => ({
            name: 'location',
            dataKey: catalog_queries_1.VirtualConnectionOrderField.CONTAINER_NAME,
            headerText: catalog_messages_1.Messages.GridHeaderLocation(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, LinkCellFormatter_1.createLinkOrTextCellFormatter)(({ containerType, containerName }) => {
                return containerType === projectContainerType ? containerName : catalog_messages_1.Messages.PersonalSpaceName();
            }, (urls, { projectVizportalUrlId, containerType }) => (projectVizportalUrlId && containerType === projectContainerType
                ? urls.projectPath(projectVizportalUrlId)
                : null)),
            resizable: true,
            sortable: true,
        }),
        (sortParams) => ({
            name: 'owner',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: catalog_messages_1.Messages.GridHeaderOwner(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, UserNameCell_1.createUserNameLinkCellFormatter)(({ owner }) => owner),
            resizable: true,
            sortable: false,
        }),
    ];
    return cols.filter(Boolean);
}
function VirtualConnectionsDisplayGrid(props) {
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const cols = columns(siteUrls).map((columnFactory) => columnFactory(props));
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.VirtualConnectionsDisplayGrid = VirtualConnectionsDisplayGrid;
function getLabelContentFromRowData(rowData, urls) {
    var _a;
    return {
        contentId: rowData.id,
        contentLuid: rowData.luid,
        contentType: rowData.contentType,
        contentName: (_a = rowData.name) !== null && _a !== void 0 ? _a : undefined,
        contentUrl: urls.virtualConnectionLineageUrl(rowData.vizportalUrlId),
        subjectArea: rowData.__typename,
    };
}
function createLabelGridColumnFormatter(urls, category) {
    function getPropsFromRowData(rowData) {
        const content = getLabelContentFromRowData(rowData, urls);
        const labels = rowData.labels ? rowData.labels : [];
        return (0, LabelsHookHelper_1.getLabelParamsForGrids)({ category, labels, urls, source: 'virtualconnections', content });
    }
    return (0, data_catalog_shared_1.createLabelColumnFormatter)((0, LabelsHookHelper_1.labelCategoryToString)(category), {
        overrides: {},
        getPropsFromRowData,
    });
}
//# sourceMappingURL=VirtualConnectionsDisplayGrid.js.map